import { useTranslation } from 'react-i18next';
import { ReturnTicket } from '@pperform/pp-data-mappers';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { CrossIcon } from 'components/CustomIcon';
import { CustomText, CustomTextDefault } from 'components/CustomText';
import {
  Container,
  Title,
  RejectReasonContainer,
  RejectReasonText,
} from './StepReturnRejected.styles';

interface StepReturnRejectedProps {
  returnTicket: ReturnTicket;
}

export const StepReturnRejected = ({
  returnTicket,
}: StepReturnRejectedProps): JSX.Element => {
  const { t } = useTranslation();
  const {
    return: { customText },
  } = usePTPConfigContext();

  return (
    <Container gap={8} justify="center" direction="column" align="center">
      <CrossIcon width={56} height={56} />
      <Title>{t('RETURN_REQUEST_REJECTED')}</Title>
      <CustomText
        text={customText.upperRejection?.text}
        defaultText={CustomTextDefault.UpperRejection}
      />
      <RejectReasonContainer>
        <RejectReasonText>{t(returnTicket.rejectReason)}</RejectReasonText>
      </RejectReasonContainer>
      <CustomText text={customText.lowerRejection?.text} />
    </Container>
  );
};
